import React, { createContext, useState, ReactNode, Dispatch, SetStateAction } from 'react';

interface DataContextType {
  sellerData: any;
  setSellerData: Dispatch<SetStateAction<any>>;
}

const defaultValue: DataContextType = {
  sellerData: {},
  setSellerData: () => {},
};

export const SellerContext = createContext<DataContextType>(defaultValue);

export const SessionProvider = ({ children }: { children: ReactNode }) => {
  const [sellerData, setSellerData] = useState<any>({});

  return (
    <SellerContext.Provider value={{ sellerData, setSellerData }}>
      {children}
    </SellerContext.Provider>
  );
};
